import Checkbox from './Checkbox';

export default Checkbox;


//////////////////
// WEBPACK FOOTER
// ../~/_rc-checkbox@2.1.8@rc-checkbox/es/index.js
// module id = 604
// module chunks = 0